import { Page } from '@/typings/page';
import useCurrentPage from '@/hooks/useCurrentPage';

import { SpecialOffer } from './SpecialOffer.types';

export function useSpecialOfferData(): Page<SpecialOffer>['templateFields'] {
  return useCurrentPage<Page<SpecialOffer>>().templateFields;
}
